import axios from "axios";

// Signed-in reads on the results page go through their own axios instance,
// without the app-wide response interceptor (AppWrapper) that clears storage
// and sends the visitor home on a 401/403. A parent opening a result email
// with an expired session should still see the results: the page treats an
// auth failure as "signed out" and falls back to the public reads instead.
const client = axios.create();

const headers = () => ({
  Authorization:
    "Basic " + window.btoa(`${process.env.REACT_APP_USERNAME}:${process.env.REACT_APP_PASSWORD}`),
  accesstoken: localStorage.getItem("accessToken"),
});

export const isAuthFailure = (error) => [401, 403].includes(error?.response?.status);

export const getWithSession = async (url) => (await client.get(url, { headers: headers() })).data;

// One dancer's results PDF, printed from the results page through the same
// isolated client (an ended session must not log the visitor out). The
// preview tab opens first (popup blockers allow it only inside the click)
// and shows the PDF, or why it could not be printed. Returns "ok",
// "auth" (session ended) or "error".
export const printWithSession = async (url, setLoading) => {
  setLoading(true);
  const tab = window.open("", "_blank");
  tab?.document?.write("Loading preview...");
  const say = (text) => {
    if (!tab?.document) return;
    tab.document.open();
    tab.document.write(text);
    tab.document.close();
  };
  try {
    const response = await client.get(url, { responseType: "arraybuffer", headers: headers() });
    const blob = new Blob([response.data], { type: "application/pdf" });
    if (tab) tab.location.href = URL.createObjectURL(blob);
    return "ok";
  } catch (error) {
    if (isAuthFailure(error)) {
      say("Your session has ended. Sign in again to print results.");
      return "auth";
    }
    say("Something went wrong");
    return "error";
  } finally {
    setLoading(false);
  }
};
